<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <div header-tag="header" header-bg-variant="dark">
        <!-- <template #header>
          <h5 class="mb-0" style="color: #fff">
            <strong>{{ $store.state.table.pelamar }}</strong>
          </h5>
        </template> -->
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #Actions="{ item }">
                <td>
                  <b-button variant="success" class="mr-1" v-c-tooltip.hover.click="'Terima'" v-b-modal.modal-detail-new @click="(data = item), (detail = !detail)">
                    <CIcon name="cil-check" />
                  </b-button>
                  <b-button
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Tolak'"
                    v-b-modal.modal-tolak
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    @click="data = item"
                  >
                    <CIcon name="cil-x" />
                  </b-button>
                  <b-button
                    variant="info"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Riwayat'"
                    v-b-modal.modal-riwayat
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    @click="(data = item), (detail = !detail)"
                  >
                    <CIcon name="cil-info" />
                  </b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </div>
    </CCol>

    <modal-input :loker="loker" @alertFromChild="triggerAlert($event)" />
    <modalDetail :data="data" :detail="detail" @alertFromChild="triggerAlert($event)" />
    <modal-riwayat :data="data" :detail="detail" />
    <modal-tolak :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalDetail from "./modalDetail.vue";
import modalRiwayat from "./modalRiwayat.vue";
import modalTolak from "./modalTolak.vue";

export default {
  components: {
    modalInput,
    modalDetail,
    modalRiwayat,
    modalTolak,
  },
  name: "pelamar",
  props: ["change"],
  data() {
    return {
      detail: false,
      data: {},
      loker: [],
      items: [],

      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaPengirim",
          label: this.$store.state.table.namaPengirim,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "alamatPengirim",
          label: this.$store.state.table.alamatPengirim,
          _style: "max-width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "emailPengirim",
          label: this.$store.state.table.emailPengirim,
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaLoker",
          label: this.$store.state.table.namaLoker,
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaPosisi",
          label: this.$store.state.table.namaPosisi,
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];
      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
  },
  mounted() {
    this.getDatas();
    this.getLoker();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    activeTab: function (newVal) {
      if (newVal == 0) {
        this.getDatas();
        this.getLoker();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPelamar = await vm.$axios.post("postLoker/listByStatusPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
        statusPostLoker: 0,
      });
      // console.log("listPelamar", listPelamar);
      vm.items =
        listPelamar.data.status == 200
          ? listPelamar.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.postLokerId,
                namaMitra: x.namaMitra || " - ",
                // posisiDilamar: `${x.namaLoker} - (Posisi : ${x.namaPosisi})`,
              };
            })
          : [];
      vm.totalRows = Number(listPelamar.data.count);
      vm.loading = false;
    },
    async getLoker() {
      let vm = this;
      let listLoker = await vm.$axios.post("loker/list");
      console.log("loker", listLoker);
      vm.loker =
        listLoker.data.status == 200
          ? listLoker.data.data.map((x) => {
              return {
                ...x,
                posisiDilamar: `${x.namaLoker} (Posisi : ${x.namaPosisi})`,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.$emit("changeVar", { name: "refreshDitolak", data: true });
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
